import { render } from "./messagesGameManual.vue?vue&type=template&id=db41fcd0"
import script from "./messagesGameManual.vue?vue&type=script&lang=js"
export * from "./messagesGameManual.vue?vue&type=script&lang=js"

import "./messagesGameManual.vue?vue&type=style&index=0&id=db41fcd0&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__